// src/apiClient.js
const API_BASE =
    process.env.REACT_APP_API_BASE || "https://mystockpicks.onrender.com";

export function getAuthToken() {
    try {
        return localStorage.getItem("authToken") || null;
    } catch (e) {
        return null;
    }
}

export async function apiFetch(path, options = {}) {
    const token = getAuthToken();

    const headers = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
    };

    const res = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers,
    });

    const text = await res.text();
    let data;

    try {
        data = text ? JSON.parse(text) : {};
    } catch (_) {
        // Backend returned HTML or non-JSON
        throw new Error(
            `Non-JSON response from ${path}: ${res.status} ${res.statusText}`
        );
    }

    if (!res.ok) {
        const msg =
            data && data.error
                ? data.error
                : `Request failed (${res.status} ${res.statusText})`;
        const err = new Error(msg);
        // so we can detect 401s
        err.status = res.status;
        throw err;
    }

    return data;
}
